import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Get, Post, Delete } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import Button from "../../../../Components/Button/Button";
import Input from "../../../../Components/Form/Input/Input";
import TextArea from "../../../../Components/Form/TextArea/TextArea";
import AddContractClauseModal from "../../../../Modals/AddContractClauseModal/AddContractClauseModal";
import { ModalAction } from "../../../../Routes/NavRouter";
import AccordianTask from "../../../../Components/AccordianTask/AccordianTask";
import css from "./ClausesView.module.css";
import PageHead from "../../../../Components/PageHead/PageHead";
import SvgOptions from "../../../../Components/Svg/SvgOptions";
import Svg from "../../../../Components/Svg/Svg";

const ClausesView = () => {
	const [clauses, setClauses] = useState([]);
	const navigate = useNavigate();
	const { openModal, closeModal } = ModalAction;

	useEffect(() => {
		fetchClauses();
	}, []);

	const fetchClauses = () => {
		Get(Url.contract.getAllClause)
			.then((resp) => {
				setClauses(resp);
			})
			.catch((err) => {
				console.error("Error fetching clauses:", err);
			});
	};

	const handleAddClause = () => {
		openModal({
			element: AddContractClauseModal,
			title: "Add Clause",
			closeModal: (resp) => {
				if (resp) {
					fetchClauses();
				}
				closeModal();
			},
		});
	};

	const handleEditClause = (clause) => {
		openModal({
			element: AddContractClauseModal,
			title: "Edit Clause",
			clause: clause,
			closeModal: (resp) => {
				if (resp) {
					fetchClauses();
				}
				closeModal();
			},
		});
	};

	const handleDeleteClause = (clauseId) => {
		ModalAction.confirm({
			title: "Confirm Delete Clause",
			text: "Are you sure you want to edit this clause? This will modify the clause in all associated contracts and templates.",
			exitText: "Close",
			okText: "Delete",
			onOk: () => {
				Delete(Url.contract.deleteClause(clauseId))
					.then(() => {
						setClauses(clauses.filter((c) => c.id !== clauseId));
					})
					.catch((err) => {
						console.error("Error deleting clause:", err);
					});
				closeModal();
			},
		});
	};

	return (
		<div className={css.ClausesView}>
			<PageHead
				title="Clauses"
				addBtn={{ text: "Clause", onClick: handleAddClause }}
				navoption={{ path: "/clauses", icon: SvgOptions.Receipt }}
				backControl={true}
			/>
			<div className={css.ClauseList}>
				{clauses.map((clause) => (
					<div key={clause.id} className={css.ClauseItem}>
						<AccordianTask key={clause.id} title={clause.name}>
							<p
								dangerouslySetInnerHTML={{ __html: clause.details }}
								className={css.ClauseDetails}
							></p>
							<div className={css.ClauseControls}>
								<button
									variant="ghost"
									size="icon"
									onClick={() => handleEditClause(clause)}
									className={css.DeleteButton}
								>
									<Svg>{SvgOptions.Edit3}</Svg>
								</button>
								<button
									variant="ghost"
									size="icon"
									onClick={() => handleDeleteClause(clause.id)}
									className={css.DeleteButton}
								>
									<Svg>{SvgOptions.Delete}</Svg>
								</button>
							</div>
						</AccordianTask>
					</div>
				))}
			</div>
		</div>
	);
};

export default ClausesView;
